<template>
    <div class="report-footer">
        <div :class="['menu', {'menu-active': menuIndex === i}]" v-for="(menu, i) in menus" @click.stop="toMenu(i)">
            <img :src="require('@/assets/home/menu-' + menu.icon + (menuIndex === i ? '-light' : '') + '.png')" v-if="menu.icon">
            <div>{{menu.title}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footer",
        props: {

        },
        data() {
            return {
                menuIndex: 0,
                menus: [
                    {
                        icon: 'gl',
                        title: '概览'
                    },
                    {
                        icon: 'ml',
                        title: '毛利'
                    },
                    {
                        icon: 'cg',
                        title: '采购'
                    },
                    {
                        icon: 'xs',
                        title: '销售'
                    },
                    {
                        icon: 'kc',
                        title: '库存'
                    }
                ]
            }
        },
        methods: {
            toMenu(i) {
                this.menuIndex = i;
                this.$emit('toPage', i)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .report-footer {
        position: absolute;
        left: 0;
        bottom: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 110px;
        .menu {
            display: flex;
            justify-content: center;
            align-items: flex-end;
            width: 214px;
            height: 110px;
            background-image: url("../assets/home/menu-bg.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: 0 0;
            cursor: pointer;
            img {
                width: 64px;
                height: 70px;
                margin-left: -6px;
                margin-right: 2px;
                margin-bottom: 10px;
            }
            div {
                font-family: PingFangSC-Semibold;
                font-size: 27px;
                color: #e6e6e6;
                letter-spacing: 1px;
                text-shadow: 0px 5px 9px rgba(1,6,34,0.42);
                text-align: left;
                font-style: normal;
                margin-bottom: 36px;
            }
        }
        .menu-active {
            background-image: url("../assets/home/menu-bg-light.png");
            div {
                color: #fff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue